import gql from 'graphql-tag';
export const UploadImage = gql `
  mutation UploadImage(
    $fileSize: Long!
    $fileName: String
    $fileType: String!
  ) {
    uploadRequest(
      input: {
        application: ARTICLES
        fileSize: $fileSize
        fileType: $fileType
        fileName: $fileName
      }
    ) {
      success {
        id
        authToken
        url
      }
    }
  }
`;
//# sourceMappingURL=upload-image.gql.js.map